import { render, staticRenderFns } from "./AnalyzesList.vue?vue&type=template&id=a84d3f46&"
import script from "./AnalyzesList.vue?vue&type=script&lang=js&"
export * from "./AnalyzesList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports